import React from "react";
import { LAYOUT } from "../theme";

// --- アイコン定義 ---
const VolumeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
    />
  </svg>
);

const MuteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
    />
    <line x1="15" y1="9" x2="21" y2="15" strokeLinecap="round" />
    <line x1="21" y1="9" x2="15" y2="15" strokeLinecap="round" />
  </svg>
);

const GoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8l-4 6h8l-4-6z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const StopIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 9h6v6H9z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const StayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </svg>
);
// --- アイコン定義ここまで ---

/**
 * 画面上部に表示されるアクションボタンのコンテナ
 */
const ActionBar = ({
  onMuteClick,
  isMuted,
  showBottomPane,
  onPauseClick,
  isPaused,
  onStayClick,
  showStayButton,
}) => {
  return (
    <div
      style={{ height: LAYOUT.actionBarHeight }}
      className="w-full bg-gray-900 px-4 flex-shrink-0 flex justify-center items-center"
    >
      {/* 中央にボタンを配置 */}
      <div className="flex items-center space-x-16">
        {/* アクセル/ブレーキボタン */}
        <button
          onClick={onPauseClick}
          className="w-12 h-12 bg-black bg-opacity-40 hover:bg-opacity-60 rounded-full flex items-center justify-center text-white transition-all duration-200"
          aria-label={isPaused ? "Go" : "Stop"}
        >
          {isPaused ? <GoIcon /> : <StopIcon />}
        </button>

        {/* 停泊ボタン（条件付き表示） */}
        {showStayButton && (
          <button
            onClick={onStayClick}
            className="w-12 h-12 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center text-white transition-all duration-200"
            aria-label="Stay"
          >
            <StayIcon />
          </button>
        )}

        {/* ミュート/ミュート解除ボタン（SORAMOYOUモードの場合のみ） */}
        {showBottomPane && (
          <button
            onClick={onMuteClick}
            className="w-12 h-12 bg-black bg-opacity-40 hover:bg-opacity-60 rounded-full flex items-center justify-center text-white transition-all duration-200"
            aria-label={isMuted ? "ミュート解除" : "ミュート"}
          >
            {isMuted ? <VolumeIcon /> : <MuteIcon />}
          </button>
        )}
      </div>
    </div>
  );
};

export default ActionBar;
